import Vue from 'vue'
import App from './App.vue'
import router from './router'
import http from './http'
import jwjURL from './config'
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'



import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';
// import utils from './utils'
import clipboard from 'clipboard';
// const bus = new Vue()

//注册到vue原型上
Vue.prototype.clipboard = clipboard;

// import './mytheme/index.less';
Vue.config.productionTip = false
Vue.prototype.baseURL = jwjURL
Vue.prototype.axios = http

// Vue.prototype.utils = utils


Vue.use(ViewUI);
Viewer.setDefaults({
  Options: {
    'inline': true,
    'button': true,
    'navbar': false,
    'title': false,
    'toolbar': false,
    'tooltip': false,
    'movable': false,
    'zoomable': false,
    'rotatable': false,
    'scalable': false,
    'transition': true,
    'fullscreen': true,
    'keyboard': false,
    'url': 'data-source'
  }
})
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')